import type { CSSObject } from "type/tss";

export const styles = () => {
	return {
		expansionTable: {
			marginBottom: "100px",
			color: "red",
		}
	} satisfies Record<string, CSSObject>;
};
